import * as Sentry from '@sentry/browser';

export const SIGNUP_EVENT_ORIGINS = [
  'https://www.facebook.com',
  'https://web.facebook.com',
];

export const COEXISTENCE_FEATURE_TYPE = 'whatsapp_business_app_onboarding';

export const SIGNUP_EVENTS = {
  FINISH: 'FINISH',
  FINISH_ONLY_WABA: 'FINISH_ONLY_WABA',
  FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING:
    'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING',
  FINISH_OBO_MIGRATION: 'FINISH_OBO_MIGRATION',
  FINISH_GRANT_ONLY_API_ACCESS: 'FINISH_GRANT_ONLY_API_ACCESS',
  CANCEL: 'CANCEL',
  ERROR: 'ERROR',
};

const UNEXPECTED_FINISH_EVENTS = new Set([
  SIGNUP_EVENTS.FINISH_OBO_MIGRATION,
  SIGNUP_EVENTS.FINISH_GRANT_ONLY_API_ACCESS,
]);

const v4ConfigId = chatwootConfig =>
  (chatwootConfig.waEsV4ConfigId || '').trim();

export function buildLoginOptions(chatwootConfig) {
  const base = {
    response_type: 'code',
    override_default_response_type: true,
  };
  if (chatwootConfig.waEsV4Enabled) {
    const v4Id = v4ConfigId(chatwootConfig);
    if (v4Id) {
      return {
        ...base,
        config_id: v4Id,
        extras: { setup: {}, featureType: COEXISTENCE_FEATURE_TYPE },
      };
    }
    Sentry.captureMessage('whatsapp_embedded_signup_v4_missing_config_id', {
      level: 'warning',
    });
  }
  return {
    ...base,
    config_id: chatwootConfig.waEsConfigId,
    extras: {
      setup: {},
      featureType: COEXISTENCE_FEATURE_TYPE,
      sessionInfoVersion: '3',
    },
  };
}

export function parseSignupEvent(messageEvent) {
  if (!SIGNUP_EVENT_ORIGINS.includes(messageEvent.origin)) return null;
  if (typeof messageEvent.data !== 'string') return null;
  let payload;
  try {
    payload = JSON.parse(messageEvent.data);
  } catch (error) {
    return null;
  }
  if (payload?.type !== 'WA_EMBEDDED_SIGNUP') return null;
  const data = payload.data || {};
  return {
    event: payload.event,
    version: payload.version,
    wabaId: data.waba_id || '',
    phoneNumberId: data.phone_number_id || '',
    businessId: data.business_id || '',
    isCoexistence:
      payload.event === SIGNUP_EVENTS.FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING,
    errorMessage: data.error_message || '',
    errorCode: data.error_code || '',
    sessionId: data.session_id || '',
    timestamp: data.timestamp || '',
    currentStep: data.current_step || '',
  };
}

export function isMetaReportedError(parsed) {
  if (parsed.event === SIGNUP_EVENTS.ERROR) return true;
  return (
    parsed.event === SIGNUP_EVENTS.CANCEL &&
    Boolean(parsed.errorMessage || parsed.errorCode)
  );
}

export function isUnexpectedFinishEvent(parsed) {
  return UNEXPECTED_FINISH_EVENTS.has(parsed.event);
}

export function reportSignupEvent(message, parsed, screen) {
  Sentry.captureMessage(message, {
    level: 'warning',
    extra: {
      screen,
      event: parsed.event,
      version: parsed.version,
      error_code: parsed.errorCode,
      session_id: parsed.sessionId,
      timestamp: parsed.timestamp,
      error_message: parsed.errorMessage,
    },
  });
}
